// Version checker to force reload on new deployments
const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes
const VERSION_FILE = '/version.json';

let currentVersion = null;
let isCheckingVersion = false;
let updateDialogCallback = null;

// Register callback to show update dialog
export const registerUpdateDialog = (callback) => {
  updateDialogCallback = callback;
};

const showUpdateDialog = () => {
  if (updateDialogCallback) {
    updateDialogCallback();
  } else {
    // Fallback to native confirm if dialog not registered
    if (window.confirm('Dostępna jest nowa wersja aplikacji. Przeładować stronę?')) {
      reloadApp();
    }
  }
};

const reloadApp = () => {
  // Clear cache and reload
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    }).finally(() => {
      window.location.reload();
    });
  } else {
    window.location.reload();
  }
};

export const handleUpdateConfirm = reloadApp;

export const initVersionChecker = () => {
  // Only run in production
  if (process.env.NODE_ENV !== 'production') {
    console.log('Version checker disabled in development');
    return;
  }

  // Get initial version
  fetch(VERSION_FILE + '?t=' + Date.now(), {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    }
  })
    .then(res => res.json())
    .then(data => {
      currentVersion = data.version;
      console.log('App version:', currentVersion);
    })
    .catch(err => console.error('Failed to get version:', err));

  // Check for updates periodically
  setInterval(() => {
    if (isCheckingVersion) return;
    
    isCheckingVersion = true;
    fetch(VERSION_FILE + '?t=' + Date.now(), {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    })
      .then(res => res.json())
      .then(data => {
        if (currentVersion && data.version !== currentVersion) {
          console.log('New version available:', data.version, '(current:', currentVersion + ')');
          showUpdateDialog();
        }
      })
      .catch(err => console.error('Version check failed:', err))
      .finally(() => {
        isCheckingVersion = false;
      });
  }, VERSION_CHECK_INTERVAL);
};

// Force reload on visibility change if version changed
export const checkVersionOnFocus = () => {
  // Only run in production
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !isCheckingVersion) {
      isCheckingVersion = true;
      fetch(VERSION_FILE + '?t=' + Date.now(), {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      })
        .then(res => res.json())
        .then(data => {
          if (currentVersion && data.version !== currentVersion) {
            console.log('New version detected on focus');
            // Show dialog when returning to tab
            showUpdateDialog();
          }
        })
        .catch(() => {})
        .finally(() => {
          isCheckingVersion = false;
        });
    }
  });
};
